/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import React from "react";
import divorceForFreeSectionStyle from "./divorceForFreeSectionStyle";
import TextContainer from "../../../Container/TextContainer";
import Typography from "@mui/material/Typography";

const DivorceForFreeSection = () => {
  return (
    <TextContainer sx={divorceForFreeSectionStyle.container}>
      <Typography variant={"h2"} sx={divorceForFreeSectionStyle.sectionHeadline}>
        Kostenlose Scheidung möglich?
      </Typography>
      <Typography variant={"h4"}>Finanzielle Unterstützung bei geringem Einkommen</Typography>
      <p>
        Sie haben ein sehr geringes Einkommen und sind daher nicht sicher, ob Sie die Scheidung bezahlen können? In Deutschland gibt es die sogenannte
        Verfahrenskostenhilfe, um geringer Verdienende bei Rechtsangelegenheiten finanziell zu unterstützen.
      </p>
      <Typography variant={"h4"}>Wie das geht?</Typography>
      <p>
        Bei Legalbird anmelden, in 5 Minuten alle Angaben zu Ihrer Scheidung machen und wir kümmern uns darum, dass für Sie Verfahrenskostenhilfe beantragt wird
        und Sie im besten Fall nichts selbst bezahlen müssen!
      </p>
    </TextContainer>
  );
};

export default DivorceForFreeSection;
